import * as actionsConversation from '../actions/conversationAction';
import HttpService from './HttpService';
import { getUrlCommunicationApi, playAudio } from '../utils/util';
import { startLoading, endLoading } from '../actions/loadingAction';

const noPlayList = [
    'OrderConfirmed',
    'OrderRefused',
    'SendToLocation',
    'RequestCIMNumber',
    'CIMConfirmed',
    'MissionFinalized',
    'MissionRefused',
    'MissionLocationRefused',
    'CIMRefused',
    'ExpeditionRefused',
    'RepickingConfirmed',
    'RepickingRefused', 'MissionRefusedCancel'];
const httpService = new HttpService(getUrlCommunicationApi(window));

export default class ConversationService {
    static sendTextToBot(text, callback, identifier, stopRecognition, startRecognition) {
        const url = `/api/conversation/bot/SendTextToBot?text=${text}&identifier=${identifier}`;
        return (dispatch) => {
            let result;
            if (navigator.onLine) {
                if (stopRecognition) {
                    stopRecognition();
                }
                dispatch(startLoading());
                httpService.instance.post(url).then((response) => {
                    if (response.status === 200) {
                        result = response.data.data;

                        if (callback) {
                            callback(result);
                        }
                        if (noPlayList.indexOf(result.message) < 0) {
                            dispatch(this.sendTextToVoice(result.message, startRecognition));
                        }
                    }
                }).catch((error) => {
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            } else {
                dispatch(endLoading());
            }
        };
    }

    static sendTextToVoice(text, callback, updateLocation) {
        const url = `/api/conversation/voice/TextToSpeech?text=${text}`;
        return async (dispatch) => {
            let result;
            if (navigator.onLine) {
                await dispatch(startLoading());
                httpService.instance.post(url).then(async (response) => {
                    if (response.status === 200) {
                        result = response.data.data;
                        await dispatch(actionsConversation.updateTextToVoiceResult(result.outputAudio));
                        if (updateLocation) await dispatch(actionsConversation.updateLocation(result.outputAudio));
                        playAudio(result.outputAudio);
                    }
                }).catch((error) => {
                    return error;
                }).finally(async () => {
                    if (callback) { callback(); }
                    await dispatch(endLoading());
                });
            } else {
                await dispatch(endLoading());
            }
        };
    }

    static sendVoiceToText(voiceB64, callback) {
        const url = '/api/conversation/voice/SpeechToText';
        return async () => {
            if (navigator.onLine) {
                await httpService.instance.post(url, {
                    audioB64: voiceB64,
                    samplaRateHertz: 16000
                }).then(async (response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback(response.data.data);
                        }
                    } else if (callback) {
                        callback('');
                    }
                }).catch((error) => {
                    return error;
                }).finally(async () => {
                });
            }
        };
    }

    static resetBot(identifier) {
        const url = `/api/conversation/bot/reset?identifier=${identifier}`;
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.post(url).then(() => {
                }).catch((error) => {
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            } else {
                dispatch(endLoading());
            }
        };
    }

    static saveConversationHistory(history) {
        const url = '/api/conversation/bot/history';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.post(url, history).then(() => {
                }).catch((error) => {
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            } else {
                dispatch(endLoading());
            }
        };
    }

    static live(callback) {
        const url = '/api/Live';
        return () => {
            if (navigator.onLine) {
                httpService.instance.get(url).then((response) => {
                    callback(response);
                }).catch((error) => {
                    callback(error);
                })
            }
        };
    }
}
